// extracted by mini-css-extract-plugin
export default {"blue02":"#1F2D42","storyWrapper":"light__storyWrapper___b6wf2"};